module.exports = __webpack_public_path__ + "media/images/img-pet-6-07f281b3.jpg";